<template ref="uploadImage">
    <div class="finish_room">
        <div class="finish_room2">
            <!-- <div :images="photo">
                <div :key="index" v-for="(item, index) in photo" class="room_img">
                    <img v-lazy="typeof item == 'string' ? item : item" />
                    <div v-if="!disabled" @click="deleteImg(index)" class="im-button">
                        <div class="im-close"></div>
                        <div class="im-close1"></div>
                    </div>
                </div>
            </div> -->
            
            <div v-if="photo.length < limit" v-loading="loading" class="room_add_img">
                <el-button type="primary" @click="add_img" size="mini">添加文件</el-button>
            </div>
            <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
              class="upload-demo"
              :on-remove="handleRemove"
              :file-list="file_list">
            </el-upload>
        </div>
        <ele-resource-other :info-data="gallery_info" v-on:picReturn="picReturn"></ele-resource-other>
    </div>
</template>

<script>
    import EleResourceOther from '@/components/EleResourceOther'
    // import axios from "axios";
    export default {
        name: "EleUploadimage",
        props: {
            limit: {
                type: Number,
                default () {
                    return 1;
                },
            },
            disabled: {
                type: Boolean,
                default () {
                    return false;
                },
            },
            isCompress: {
                type: Boolean,
                default () {
                    return false;
                },
            },
            value: {
                type: [String, Array, File, Blob],
                default () {
                    return [];
                },
            },
        },
        components: {
            EleResourceOther
        },
        data: function() {
            return {
                photo: [],
                loading: false,
                gallery_info: {
                    status: false,
                    num: 1,
                },
                file_list:[]
            };
        },
        watch: {
            photo() {
                if (this.photo.length > 0) {
                    if (this.limit == 1) {
                        this.$emit("input", this.photo[0]);
                    } else {
                        this.$emit("input", this.photo);
                    }
                }
            },
            value: {
                immediate: true,
                handler: function() {
                    var temp_data = {}
                    this.file_list = [];
                    if (typeof this.value == "string") {
                        if (this.value == "") {
                            this.photo = [];
                            this.file_list = [];
                        } else {
                            this.photo = [this.value];
                            temp_data = {
                                name:this.value,
                                url:this.value
                            }
                            this.file_list.push(temp_data);
                        }
                    } else if (this.value instanceof Array) {
                        this.photo = this.value;
                        for(var i = 0;i<this.value.length;i++){
                            var temp = {
                                name:this.value[i],
                                url:this.value[i]
                            }
                            this.file_list.push(temp);
                        }
                    } else {
                        try {
                            let fileReader = new FileReader();
                            fileReader.readAsDataURL(this.value);
                            fileReader.onload = (e) => {
                                this.photo = [e.target.result];
                            };
                        } catch (e) {
                            console.log(e.message)
                        }
                    }
                },
            },
        },
        methods: {
            handleRemove(file, fileList){
                this.file_list = JSON.parse(JSON.stringify(fileList));
                this.photo = [];
                for(var i = 0;i<fileList.length;i++){
                    this.photo.push(fileList[i].url);
                }
            },
            /* 图库选择返回数据*/
            picReturn(e) {
                console.log(e);
                    var temp_data = {
                        name:e.data[0].title,
                        url:e.data[0].file
                    }
                    this.photo.push(e.data[0].file)
                    this.file_list.push(temp_data);
                    console.log()
            },
            
            deleteImg(index) {
                this.photo.splice(index, 1);
                if (this.limit == 1) {
                    this.$emit("input", "");
                } else {
                    this.$emit("input", this.photo);
                }
                this.$emit("update:value", null);
            },
            compress(img) {
                var url = null;
                var canvas = document.createElement("canvas");
                var scale = img.height / img.width;
                canvas.width = 720;
                canvas.height = 720 * scale;

                var ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                url = canvas.toDataURL("image/jpeg");
                return url;
            },
            dataURItoBlob(dataURI) {
                let byteString = window.atob(dataURI.split(",")[1]);
                let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
                let ab = new ArrayBuffer(byteString.length);
                let ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new window.Blob([ab], {
                    type: mimeString
                });
            },
            add_img(){
                this.gallery_info.status = true;
            },
        },
    };
</script>
<style>
    .finish_room {
        /*width: 140px;*/
        /*height: 165px;*/
    }

    img {
        height: 100%;
    }

    .finish_room2 {
        width: 100%;
        height: 100%;
    }

    .finish_room2>div {
        display: flex;
        flex-wrap: wrap;
    }

    .finish_room2 .margeImg {
        margin-left: 10px;
    }

    .finish_room2 .room_img {
        width: 100px;
        height: 100px;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.5);
        margin-left: 10px;
        margin-top: 10px;
    }

    .finish_room2 .room_img:before {
        /*content: "";*/
        /*width: 0;*/
        /*height: 100%;*/
        /*!*background: #000;*!*/
        /*padding: 14px 18px;*/
        /*position: absolute;*/
        /*top: 0;*/
        /*left: 50%;*/
        /*opacity: 0;*/
    }

    .finish_room2 .room_img:hover:before {
        width: 100%;
        left: 0;
        opacity: 0.5;
    }

    .finish_room2 .room_img .box-content {
        width: 100%;
        padding: 14px 18px;
        color: #fff;
        position: absolute;
        top: 38%;
        left: 0;
    }

    .finish_room2 .room_img .icon {
        padding: 0;
        margin: 0;
        list-style: none;
        margin-top: -20px;
    }

    .finish_room2 .room_img .icon li {
        display: inline-block;
    }

    .finish_room2 .room_img .icon li i {
        display: block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 50%;
        font-size: 20px;
        font-weight: 700;
        color: #fff;
        margin-right: 25px;
        opacity: 0;
        transform: translateY(50px);
        transition: all 0.5s ease 0s;
    }

    @media only screen and (max-width: 990px) {
        .finish_room2 .room_img {}
    }

    .finish_room2 .deleteImg {
        color: red;
        position: absolute;
        top: 0px;
        left: 80px;
        cursor: pointer;
    }

    .finish_room2 .room_img img {
        cursor: pointer;
        width: 100px;
        height: 100px;
    }

    .finish_room2>.room_img span {
        position: absolute;
        width: auto;
        height: auto;
        right: 5px;
        bottom: 3px;
    }

    .finish_room2 .im-button {
        position: absolute;
        top: -14px;
        right: -18px;
        width: 40px;
        height: 40px;
        cursor: pointer;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.5);
        opacity: 0;
    }

    .finish_room2 .room_img:hover .icon li i {
        opacity: 0.5;
    }

    .finish_room2 .room_img:hover img {
        opacity: 0.5;
    }

    .finish_room2 .room_img:hover .im-button {
        opacity: 1;
    }

    .finish_room2 .im-close {
        transform: rotate(-45deg);
        line-height: 0px;
        left: 6px;
        bottom: 13px;
        display: inline-block;
        width: 15px;
        height: 2px;
        background: #fff;
        position: absolute;
    }

    .finish_room2 .im-close1 {
        left: 5px;
        bottom: 13px;
        display: inline-block;
        width: 15px;
        height: 2px;
        background: #fff;
        position: absolute;
        transform: rotate(45deg);
    }


    
</style>
